export class TrainingCatgoriesAndSections {
    public TrainingCategories: TrainingCategoriesVM[];
    public ParentCategories: TrainingCategoriesVM[];
    public CategorySections: TrainingCategoriesVM[];
    public Trainings: TrainingVM[];
    public isLoggedUser:boolean;
    public MainParentCategories: TrainingCategoriesVM[];
}

export class TrainingCategoriesVM {

    public TrainigCatId: number;
    public TrainigCatName: string;
    public Order: number;
    public IsParent: boolean;
    public ParentCatId: number;
    public ParentCatName: string;
    public Active: boolean;
    public SectionCount: number;
    public TrainingCount: number;
    public MainParentId:number;
    public isExpanded :boolean=false;  
}

export class TrainingVM {
    public TrainingId: number;
    public TrainingName: string;
    public TrainingTypeId: number;
    public Order: number;
    public Active: boolean;
    public Status:number;
    public SessionId:number;
    public IsVideoUrl: boolean;
}

export class TrainingCatVM {
    public Id: number;
    public Name: string;
    public Order: number;
    public ParentId :number;
    public MainParentId:number;
    public Trainings: TrainingVM[];
    public SubCatList:TrainingCatVM[];
}

export class TrainingSubSectionsVM {
    public TrainigSubId: number;
    public TrainigSubName: string;
    public Order: number;
    public ParentTrainingId: number;
    public Active: boolean;
    public SlideCount: number;
}

export class TrainingSlidesVM {
    public SlideId: number;
    public SlideName: string;
    public isLink: boolean;
    public Order: number;
    public Active: boolean;
    public SubSectionId: number;
    public SlideTypeId: number;
    public SlideImage: string;
    public YoutubeLink: string;
    public TrainingId: number;

}
export class QuestionsVM {
    public QuestionId: number;
    public QuestionName: string;
    public SubSectionId: number;
    public TrainingId: number;
    public QuestionTypeId: number;
    public SlideId: number;
    public AnswerCount: number;
    public Order: number;
    public Active: boolean;
    public SlideName: string;
    public QuestionTypeName: string
    public AnswerList: AnswersOptionsVM[];
    public Invalid:boolean=false;
}

export class AnswersOptionsVM {
    public AnswerId: number;
    public Name: string;
    public Select: boolean;
    public UserSelect:boolean=false;
    public Id:number;
}

export class TrainingInfo {
    public SubTrainings: TrainingSubSectionsVM[];
    public Slides: TrainingSlidesVM[];
    public QuestionTypes: QuestionTypes[];
    public TrainingQuestions:QuestionsVM[];
    public NextTrainingId: number;
    public FinishTraining: boolean;
    public CurrentTraining: TrainingSlideSection;
}

export class QuestionTypes {
    public Id: number;
    public Title: string;
}

export class UserListVM{
    public Id: number;
    public Name: string;
}

export class TrainingPreviewVM{
    public TrainingId: number;
    public TrainingName: string;
    public TrainingType: string;
    public UserId: number;
    public UserName: string;
}

export interface TrainingSlideSection {
  Id: number;
  Title: string;
  TrainigTypeID?: number;
  Order: number;
  Active: boolean;
}